import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const InternalVsExternalSupport6 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="internalVsExternalSupport" section="hybrid">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="internalVsExternalSupport:hybrid" first noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default InternalVsExternalSupport6;
